import styled from 'styled-components';

export const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const ContentContainer = styled.div``;
